export default "__VITE_ASSET__9de00577__"